class ColourCellRenderer {
  eGui;

  init(params) {
    const eGui = (this.eGui = document.createElement("div"));
    eGui.style.overflow = "hidden";
    eGui.style.textOverflow = "ellipsis";

    const { value } = params;
    const colorSpan = document.createElement("span");
    const text = document.createTextNode(value ?? "");

    if (value != null) {
      switch (value) {
        case "1-Open To List":
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Green 90%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Green 50%)`;
          colorSpan.style.borderColor = "Green";
          colorSpan.style.color = "white";
          break;
        case "2-Click and Approved":
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Yellow 100%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Yellow 50%)`;
          colorSpan.style.borderColor = "Yellow";
          break;
        case "3-Brand Application":
          colorSpan.style.borderColor = "Pink";
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Pink 100%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Pink 50%)`;
          break;
        case "4-Invoice Required":
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Red 90%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Red 50%)`;
          colorSpan.style.borderColor = "Red";
          colorSpan.style.color = "white";
          break;
        case "5-eBay":
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Blue 90%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Blue 50%)`;
          colorSpan.style.borderColor = "Blue";
          colorSpan.style.color = "white";
          break;
        case "6-walmart":
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Purple 90%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Purple 50%)`;
          colorSpan.style.borderColor = "Purple";
          colorSpan.style.color = "white";
          break;
        case "7-Other":
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Orange 90%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Orange 50%)`;
          colorSpan.style.borderColor = "Orange";
          colorSpan.style.color = "white";
          break;
        case "99-Do Not List":
          colorSpan.style.backgroundColor = `color-mix(in srgb, transparent, Grey 90%)`;
          colorSpan.style.boxShadow = `0 0 0 1px color-mix(in srgb,transparent,  Grey 50%)`;
          colorSpan.style.borderColor = "Grey";
          colorSpan.style.color = "white";
          break;
        default:
          break;
      }
      colorSpan.style.width = "150px";
      colorSpan.style.padding = "5px";
      colorSpan.style.borderRadius = "5px";
      colorSpan.append(text);
      colorSpan.style.paddingRight = "5px";
    }

    eGui.appendChild(colorSpan);
    //eGui.append(text);
  }

  getGui() {
    return this.eGui;
  }

  refresh() {
    return false;
  }
}
export default ColourCellRenderer;
